/*
* @描述: 关联订单弹窗
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/18 20:52
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose">
                </ReturnNavBar>
            </div>
            <div class="relate_table_search">
                <van-search v-model="select_order_keyword"
                            placeholder="请输入需要查询的内容"
                            @search="onSearch"/>
                <span class="handle_icon_wrap" @click="showDateRangePicker=true">
                    <i class="iconfont icon-rili1"></i>
                </span>
            </div>
            <div v-loading="loading" class="detail_wrap_container">
                <ul v-infinite-scroll="scrollLoadRelateOrderList">
                    <li v-for="row in orderList"
                        :key="row.order_id"
                        class="detail_chunk_wrap"
                        @click="handleClickOrderRow(row)">
                        <div class="order_num_wrap">
                            <span v-text="row.order_num" @click.stop="handleClickOrderDetail(row)"></span>
                        </div>
                        <div>
                            <div class="m_detail_form_item mb_8">
                                <div class="form_item_label">关联客户：</div>
                                <div class="form_item_value" v-text="row.customer_name"></div>
                            </div>
                            <div class="m_detail_form_item mb_8">
                                <div class="form_item_label">销售：</div>
                                <div class="form_item_value">
                                    <div class="custom_contact_field_wrap">
                                        <PersonnelCard v-if="row.salesperson"
                                                       :userId="row.salesperson">
                                            <template slot="container">
                                                <img :src="row.salesperson_avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.salesperson_name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                            </div>
                            <div class="m_detail_form_item">
                                <div class="form_item_label">订单总金额：</div>
                                <div class="form_item_value" v-text="'¥'+row.total_price"></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <!--日期区间选择-->
            <van-calendar v-model="showDateRangePicker"
                          :allow-same-day="true"
                          :max-date="dateCalendarMax"
                          :min-date="dateCalendarMin"
                          :show-confirm="false"
                          color="#1990FF"
                          type="range"
                          @close="showDateRangePicker=false"
                          @confirm="handleClickRangeCalendarConfirm">
            </van-calendar>
        </div>
    </van-popup>
</template>
<script>
import {getOrderList} from "@/api";
import {pagination} from "@/mixins";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import {formatDate} from "@/utils";

export default {
    name: "RelateOrderSelect",
    data() {
        return {
            loading: false,
            orderList: [],
            select_order_keyword: '',
            created_at: [],
            defaultImg: require('@/assets/images/default.jpg'),
            showDateRangePicker: false,
            dateCalendarMin: new Date('1970-01-01'),
            dateCalendarMax: new Date('2049-10-01'),
        }
    },
    mixins: [pagination],
    components: {PersonnelCard, ReturnNavBar},
    props: {
        //是否为预览模式时候选择
        is_preview_mode: {
            type: Boolean,
            default: false
        },
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        projectId: {
            type: Number,
            default: 0,
        }, //项目id
        projectOrderId: {
            type: Number,
            default: 0,
        }, //商机id
    },
    created() {
        this.getOrderList()
    },
    mounted() {
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        getOrderList() {
            this.loading = true
            getOrderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.select_order_keyword,
                created_at: this.created_at ? this.created_at : [],
                project_manage_id: this.projectId ? this.projectId : undefined,
                project_id: this.projectOrderId ? this.projectOrderId : undefined,
                status: 0,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.orderList = this.orderList.concat(data)
                    this.pagination.total = total
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },

        onSearch() {
            this.pagination.pageNum = 1
            this.orderList = []
            this.getOrderList()
        },

        scrollLoadRelateOrderList() {
            if (this.pagination.pageNum * this.pagination.pageSize < this.pagination.total) {
                this.pagination.pageNum++
                this.getOrderList()
            }
        },

        //点击日期区间选择器确定事件
        async handleClickRangeCalendarConfirm(range) {
            const [start, end] = range
            this.created_at = [formatDate(start, 'date'), formatDate(end, 'date')]
            this.pagination.pageNum = 1
            this.orderList = []
            this.getOrderList()
            this.showDateRangePicker = false
        },

        //点击选择订单
        handleClickOrderRow(row) {
            this.$emit('update:dialogVisible', false)
            this.$emit('success', row)
        },

        //点击查看商机详情
        handleClickBusinessDetail(row) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: row.project_id,
                    name: row.project_name,
                },
            });
        },

        //点击查看关联客户详情
        handleClickCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id,
                    name: row.customer_name,
                },
            });
        },

        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id,
                    name: row.order_num,
                },
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.relate_table_search {
    position: relative;

    .van-search {
        padding: 6px 16px;
    }

    .handle_icon_wrap {
        position: absolute;
        right: 40px;
        top: 12px;
    }
}

.detail_wrap_container {
    background-color: #F7F8FA;
    padding-top: 10px;

    .order_num_wrap {
        padding-bottom: 8px;
        border-bottom: 1px solid #E8E8E8;
        margin-bottom: 8px;
        font-weight: bold;
        color: #2990FF;
    }

    .m_detail_form_item {
        justify-content: start;

        .form_item_value {
            text-align: left;
        }
    }
}
</style>